import { render, staticRenderFns } from "./IncidentList.vue?vue&type=template&id=37fae50d"
import script from "./IncidentList.vue?vue&type=script&lang=js"
export * from "./IncidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports